import React from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <React.Fragment>
            <footer className="footer bg-white shadow-lg text-gray-800 px-6 py-8">
                <div className="container mx-auto">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        {/* Left section */}
                        <div className="text-center md:text-left mb-6 md:mb-0">
                            <p className="text-sm md:text-base">
                                {currentYear} © <span className="font-semibold text-[#ae3e34]">Bricks N Bar</span>.
                            </p>
                        </div>

                        {/* Right section */}
                        <div className="text-center md:text-right">
                            <p className="text-sm md:text-base">
                                Designed & Developed by
                                <a href="#" className="text-[#ae3e34] hover:underline ml-1 font-medium">
                                    Web-Bocket
                                </a>
                            </p>
                        </div>
                    </div>

                    {/* Additional Styling for Mobile */}
                    <div className="text-center mt-4">
                        <p className="text-xs text-gray-500 md:text-sm">Built with care and passion.</p>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
